import { Box, TextField, InputAdornment, Typography } from "@mui/material";
import { WidgetProps } from "@rjsf/utils";
import { inputStyles, renderLabel, renderDescriptionTooltip } from "./common";

// Text Input Widget with maxLength support and character counter
export const TextWidget = (props: WidgetProps) => {
  const { id, value, label, onChange, required, disabled, readonly, placeholder, options, schema } = props;
  const maxLength = (options?.maxLength || schema?.maxLength) as number | undefined;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const val = event.target.value;
    if (val === "") {
      onChange(undefined);
      return;
    }
    if (maxLength && val.length > maxLength) {
      return;
    }
    onChange(val);
  };

  const currentLength = (value ?? "").length;
  const showCounter = maxLength && currentLength > maxLength * 0.7;

  return (
    <Box>
      <TextField
        id={id}
        fullWidth
        value={value ?? ""}
        onChange={handleChange}
        disabled={disabled}
        slotProps={{
          input: {
            readOnly: readonly,
            endAdornment: (
              <InputAdornment position="end">
                {showCounter && (
                  <Typography
                    variant="caption"
                    color={currentLength >= maxLength ? "error" : "text.secondary"}
                    sx={{ mr: 1 }}
                  >
                    {currentLength}/{maxLength}
                  </Typography>
                )}
                {renderDescriptionTooltip(schema.description)}
              </InputAdornment>
            ),
          },
          htmlInput: {
            maxLength,
          },
        }}
        placeholder={placeholder}
        label={renderLabel(label, !!required)}
        required={required}
        size="small"
        variant="outlined"
        sx={inputStyles}
      />
    </Box>
  );
};
